module.exports = __webpack_public_path__ + "img/start.1a06c370.png";